import React from 'react';

import { ALL_ASSET_TYPES } from '@nile/rmm/src/constants';

import AssetManagementViewList from '@nile/rmm/src/modules/asset-management/components/sub-pages/asset-management-view-list/asset-management-view-list';
import AllMonitoredAssetView from '@nile/rmm/src/modules/asset-management/components/sub-pages/all-monitored-assets-view/all-monitored-assets-view';
import { isEmpty } from 'lodash';

interface ActiveView {
  id: string;
  viewSubType: string;
}

interface AllAssetsManagementViewProps {
  tab: string;
  activeView: ActiveView;
  handleFilterChange: Function;
  listInfo: any;
  source?: string;
  classId?: string;
  padded?: string;
  checkBoxSize?: string;
  defaultListFilters?: any;
  defaultColumnsToExclude?: string[];
  isClientDetailsPage?: boolean;
  noBulkSelect?: boolean;
  isPolicyCategory?: boolean;
  assetClassId?: string;
  supportedModules?: string[];
  reRenderOnDefaultFilterChange: boolean;
  tableName: string;
}

function AllAssetsManagementView({
  activeView,
  source,
  classId,
  defaultListFilters = null,
  padded = 'sm',
  checkBoxSize = 'md',
  defaultColumnsToExclude = [],
  isClientDetailsPage = false,
  noBulkSelect = false,
  isPolicyCategory = false,
  assetClassId,
  supportedModules,
  reRenderOnDefaultFilterChange = false,
  tableName,
  tab
}: AllAssetsManagementViewProps) {
  let content;
  switch (activeView?.viewSubType) {
    case ALL_ASSET_TYPES.ALL_ASSETS:
    case ALL_ASSET_TYPES.ALL_MONITORED_ASSET:
    case ALL_ASSET_TYPES.ALL_NON_MONITORED_ASSET:
    case ALL_ASSET_TYPES.PRINTER_ASSET:
    case ALL_ASSET_TYPES.FIREWALL_ASSET:
    case ALL_ASSET_TYPES.SWITCH_ASSET:
    case ALL_ASSET_TYPES.ROUTER_ASSET:
    case ALL_ASSET_TYPES.UPS:
    case ALL_ASSET_TYPES.LOAD_BALANCER:
    case ALL_ASSET_TYPES.POWER_DISTRIBUTION_UNIT:
    case ALL_ASSET_TYPES.STORAGE:
    case ALL_ASSET_TYPES.WAN_ACCELERATOR:
    case ALL_ASSET_TYPES.WIRELESS_ACCESS_POINT:
    case ALL_ASSET_TYPES.WIRELESS_LAN_CONTROLLER:
    case ALL_ASSET_TYPES.VOIP:
    case ALL_ASSET_TYPES.IP_CAMERA:
    case ALL_ASSET_TYPES.NAS:
    case ALL_ASSET_TYPES.SERVER_HARDWARE_CONTROLLER_ASSET:
    case ALL_ASSET_TYPES.WAN_ROUTER_ASSET:
    case ALL_ASSET_TYPES.NETWORK_VIDEO_RECORDER_ASSET:
    case ALL_ASSET_TYPES.ETHERNET_IP_BRIDGE_ASSET:
    case ALL_ASSET_TYPES.TEMPERATURE_SENSOR_ASSET:
    case ALL_ASSET_TYPES.DOMAIN_CONTROLLER_ASSET:
    case ALL_ASSET_TYPES.VMWARE_ESXI_ASSET:
    case ALL_ASSET_TYPES.ENVIRONMENTAL_MONITORING_DEVICE_ASSET:
    case ALL_ASSET_TYPES.SERIAL_DEVICE_SERVER_ASSET:
    case ALL_ASSET_TYPES.PRESENTATION_GATEWAY_ASSET:
    case ALL_ASSET_TYPES.VOIP_GATEWAY_ASSET:
    case ALL_ASSET_TYPES.USB_HUB_ASSET:
    case ALL_ASSET_TYPES.X_TERMINAL_ASSET:
    case ALL_ASSET_TYPES.ETHERNET_GATEWAY_ASSET:
    case ALL_ASSET_TYPES.PBX_ASSET:
    case ALL_ASSET_TYPES.ETHERNET_CARD_ASSET:
    case ALL_ASSET_TYPES.AUDIO_CODEC_ASSET:
    case ALL_ASSET_TYPES.RF_TRANSMITTER_ASSET:
    case ALL_ASSET_TYPES.TAPE_LIBRARY_ASSET:
    case ALL_ASSET_TYPES.KVM_SWITCH_ASSET:
    case ALL_ASSET_TYPES.ZERO_CLIENT_ASSET:
    case ALL_ASSET_TYPES.BARCODE_PRINTER_ASSET:
    case ALL_ASSET_TYPES.SAN_ASSET:
    case ALL_ASSET_TYPES.ANDROID_ASSET:
    case ALL_ASSET_TYPES.APPLE_IOS_ASSET:
    case ALL_ASSET_TYPES.APPLE_IPADOS_ASSET:
      content = (
        // eslint-disable-next-line react/jsx-filename-extension
        <AllMonitoredAssetView
          source={!isEmpty(source) ? source : 'ASSET_VIEW'}
          activeView={activeView}
          viewSubType={activeView?.viewSubType}
          padded={padded}
          checkBoxSize={checkBoxSize}
          defaultFilters={defaultListFilters}
          defaultColumnsToExclude={defaultColumnsToExclude}
          isClientDetailsPage={isClientDetailsPage}
          noBulkSelect={noBulkSelect}
          isPolicyCategory={isPolicyCategory}
          assetClassId={assetClassId}
          supportedModules={supportedModules}
          reRenderOnDefaultFilterChange={reRenderOnDefaultFilterChange}
          tableName={tableName}
          tab={tab}
        />
      );
      break;
    default:
      content = (
        <AssetManagementViewList
          activeView={activeView}
          source={!isEmpty(source) ? source : 'ASSET_VIEW'}
          padded={padded}
          checkBoxSize={checkBoxSize}
          classId={classId}
          defaultFilters={defaultListFilters}
          defaultColumnsToExclude={defaultColumnsToExclude}
          isClientDetailsPage={isClientDetailsPage}
          tab={tab}
        />
      );
      break;
  }

  return <>{content}</>;
}

export default AllAssetsManagementView;
